var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramValuable40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "5.26315789 0 12.5 0 19.7368421 0 25 7.78378378 12.5 24 0 7.78378378"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "11.6652832 0 0 16.1433105 4.69592285 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.09149454,7.21111389 L5.5,20.8258431 L9.90850546,7.21111389 L5.5,0.995958772 L1.09149454,7.21111389 Z M11,7.1461489 L5.5,24 L0,7.1461489 L4.9897516,0 L6.0102484,0 L11,7.1461489 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-7",
    points: "19.7368421 0 25 7.78378378 12.5 24 0 7.78378378 5.26315789 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-9",
    points: "0 0 23 0 23 1 0 1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Valuable40",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search40"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(7.500000, 9.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "-3.28947368 -3.24324324 28.2894737 -3.24324324 28.2894737 27.2432432 -3.28947368 27.2432432"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(12.500000, 7.500000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#FFCC00",
    mask: "url(#mask-4)",
    points: "-3.83302781 -3.76925365 14.8330278 -3.76925365 14.8330278 19.7692534 -3.83302781 19.7692534"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(7.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#4F4C4D",
    mask: "url(#mask-6)",
    points: "-3.30283515 -3.2482495 14.3028352 -3.2482495 14.3028352 27.2482493 -3.30283515 27.2482493"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-11"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-10",
    stroke: "#4F4C4D",
    strokeWidth: 2,
    strokeLinecap: "square",
    mask: "url(#mask-8)",
    points: "5.26315789 0 12.5 0 19.7368421 0 25 7.78378378 12.5 24 0 7.78378378"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(1.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#4F4C4D",
    mask: "url(#mask-10)",
    points: "-3.23943662 -3.33333333 26.2394366 -3.33333333 26.2394366 4.33333333 -3.23943662 4.33333333"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramValuable40);
export default __webpack_public_path__ + "static/media/pictogramValuable40.7a9527ed55ae3ade215d1d8961c5aa80.svg";
export { ForwardRef as ReactComponent };